/**
 * PLT-5741: client submit for per-message chat feedback.
 *
 * Wraps `POST /api/chat/feedback` (registered in
 * `services/main/upserve/modules/chat/feedback.ts`). The vote control calls
 * `submitChatFeedback` directly rather than through a react-query mutation: a
 * vote is fire-and-forget UI state (the control owns the optimistic
 * filled/empty state and reverts on failure), and there's no cache entry to
 * invalidate — the persisted vote is only ever read back on a full reload,
 * through the conversation-detail endpoint.
 *
 * Passing `rating: null` clears an existing vote (the user un-toggled their
 * thumb); the server deletes the row and the log marker.
 */
import { fetchOrThrowNoReturnData } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import type { ChatFeedbackRequest } from '@upright/common/chat/feedback-types';

export async function submitChatFeedback(body: ChatFeedbackRequest): Promise<void> {
  await fetchOrThrowNoReturnData('/chat/feedback', 'POST', body);
}
